import module from '@kendu/ui/module'

class KdModalComponent {
  constructor ($attrs, $scope, $element, $transclude, $q, $parse, KdElementModalService) {
    const parser = $parse($attrs.kdModal)

    if (!parser.assign) {
      return
    }

    this.$attrs = $attrs
    this.$element = $element
    this.$transclude = $transclude
    this.$q = $q
    this.KdElementModalService = KdElementModalService
    this.modal = null
    this.promise = null
    this.assign = (value) => parser.assign($scope, value)
  }

  $onDestroy () {
    this.cancel()
  }

  $onInit () {
    if (this.assign) {
      this.assign({
        open: this.open.bind(this),
      })
    }
  }

  close (data) {
    if (this.promise) {
      this.promise.resolve(data)

      this.promise = null
    }

    this.clear()
  }

  cancel () {
    if (this.promise) {
      this.promise.reject()

      this.promise = null
    }

    this.assign(undefined)

    this.clear()
  }

  clear () {
    if (this.modal) {
      this.modal.element.remove()
      this.modal.scope.$destroy()
      this.modal.deregister()
      this.modal = null
    }
  }

  open () {
    if (this.promise) {
      return this.promise.promise
    }

    this.$transclude((clone, scope) => {
      this.modal = {
        element: clone,
        scope: scope,
        deregister: this.KdElementModalService.add(clone),
      }

      clone.on('destroy', () => this.cancel())
    })

    this.promise = this.$q.defer()

    return this.promise.promise
  }
}

module.directive('kdModal', () => ({
  controller: KdModalComponent,
  restrict: 'A',
  transclude: 'element',
  priority: 500,
  terminal: true,
}))



// WEBPACK FOOTER //
// ./src/kendu/ui/directives/kd-modal/directive.js